<template>
  <el-drawer
    title="合作产品详情"
    append-to-body
    :close-on-press-escape="false"
    :visible.sync="show"
    size="720px"
    direction="rtl">
    <div class="detail-drawer-wrap">
      <el-descriptions
        title="基础信息"
        :column="2">
        <el-descriptions-item label="产品名称">{{ ruleForm.goodsName }}</el-descriptions-item>
        <el-descriptions-item label="所属企业">{{ ruleForm.vendorName }}</el-descriptions-item>
        <el-descriptions-item label="排序值">{{ ruleForm.sortNumber }}</el-descriptions-item>
        <el-descriptions-item label="产品品牌">{{ ruleForm.brandName }}</el-descriptions-item>
        <el-descriptions-item label="产品产地">{{ ruleForm.originregion }}</el-descriptions-item>
        <el-descriptions-item label="净含量">{{ ruleForm.netContent }}</el-descriptions-item>
        <el-descriptions-item label="保质期">{{ ruleForm.shelflife }}</el-descriptions-item>
        <el-descriptions-item label="是否上架">{{ ruleForm.status === 1 ? '已上架' : '已下架' }}</el-descriptions-item>
        <el-descriptions-item
          label="自定义属性"
          :span="2">
          <el-table
            border
            :data="ruleForm.attributes">
            <el-table-column
              label="属性名"
              prop="name"
              min-width="80">
            </el-table-column>
            <el-table-column
              label="属性值"
              prop="value"
              min-width="160">
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        title="图片信息"
        :column="1">
        <el-descriptions-item label="产品首图">
          <image-list
            :list="ruleForm.goodsSmallImage"
            :listType="3" />
        </el-descriptions-item>
        <el-descriptions-item label="产品介绍">
          <desc-images v-model="ruleForm.goodsDetailsImage"></desc-images>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions
        title="证书信息"
        :column="1">
        <el-descriptions-item label="证书列表">
          <el-table
            border
            :data="ruleForm.certs">
            <el-table-column
              label="证书名称"
              prop="certName"
              min-width="160">
            </el-table-column>
            <el-table-column
              label="证书图片"
              min-width="300px">
              <template slot-scope="{row}">
                <image-list
                  :list="row.certFile"
                  :listType="3"
                  style="--image-width:48px;--image-height: 48px" />
              </template>
            </el-table-column>
            <el-table-column
              label="有效期"
              min-width="180">
              <template slot-scope="{row}">{{ row.certBeginTime | dateformat('YYYY-MM-DD') }} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD') }}</template>
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>
<script>
import ImageList from '@/components/image-list.vue'
import DescImages from '@/components/public/desc-images.vue'
export default {
  name: 'GoodsDetailDrawer',
  components: { ImageList, DescImages },
  data() {
    return { show: false, loading: false, config: { goodsDetailsImage: [], goodsSmallImage: '' }, ruleForm: {}}
  },
  methods: {
    fetch(options) {
      const { goodsDetailsImage } = options
      this.ruleForm = { ...this.ruleForm, ...options, goodsDetailsImage: this.$splitImage(goodsDetailsImage) }
      this.show = true
    }
  }
}
</script>
<style lang="stylus" scoped>
  .images-wrap {
    width 256px
    height 400px
    overflow-y auto
  }
</style>
